const msMY = {
  'modal.close': 'Tutup',
  'session_expired.title': 'Sesi telah tamat tempoh',
  'tokenizationForm.payment-terms.text1':
    'Saya membenarkan Flywire menyimpan dan mengenakan caj ke atas kad debit/kredit saya secara automatik bagi pihak {{recipientName}}. Saya telah membaca, memahami dan bersetuju dengan',
  'tokenizationForm.general-terms.link2': 'Dasar Privasi',
  'tokenizationForm.general-terms.link-joint': ' dan ',
  'tokenizationForm.general-terms.link1': 'Terma Penggunaan',
  'tokenizationForm.payment-terms.link': 'Terma Penggunaan Flywire untuk pembayaran automatik',
  'tokenizationForm.labels.cvvTooltip': '3 digit di belakang kad anda atau 4 digit di hadapan kad',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': 'Tarikh luput (BB/TT)',
  'tokenizationForm.labels.cardNumber': 'Nombor kad',
  'tokenizationForm.labels.phone': 'Nombor telefon',
  'tokenizationForm.labels.upopPhone':
    'Sila masukkan nombor telefon bimbit yang dipautkan pada kad bank ini',
  'tokenizationForm.labels.zip': 'Poskod',
  'tokenizationForm.labels.address': 'Alamat',
  'cardsForm.labels.state': 'Negeri',
  'tokenizationForm.labels.country': 'Negara atau rantau',
  'tokenizationForm.labels.city': 'Bandar',
  'tokenizationForm.labels.email': 'E-mel',
  'tokenizationForm.labels.lastName': 'Nama keluarga',
  'tokenizationForm.labels.firstName': 'Nama pertama',
  'cardsForm.title': 'Maklumat pemegang kad',
  'success.title': 'Dana anda sedang dalam perjalanan',
  'success.title.info':
    'Sila benarkan 2-3 hari bekerja untuk dana tiba.\nAnda akan menerima e-mel apabila dana telah dihantar.',
  'bankAccountForm.hints.generic': 'Contoh: {{label}}',
  'bankAccountForm.hints.account_number': 'Panjang nombor akaun mestilah antara 1 hingga 17 aksara',
  'bankAccountForm.hints.routing_number': 'Panjang nombor penghalaan mestilah 9 digit',
  'bankAccountForm.labels.accountZipCode': 'Poskod',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'Kod BIC',
  'bankAccountForm.labels.accountNumber': 'Nombor akaun',
  'bankAccountForm.labels.accountSortCode': 'Kod sort',
  'bankAccountForm.labels.accountRoutingNumber': 'Nombor penghalaan',
  'bankAccountForm.labels.accountType': 'Jenis akaun',
  'bankAccountForm.labels.eftProviderWidnow':
    'Anda akan dibawa ke platform pemprosesan rakan kongsi untuk melengkapkan pembayaran ini. Setelah selesai, anda akan dialihkan semula ke halaman ini',
  'bankAccountForm.labels.termsFlywire':
    "Saya telah membaca, memahami dan bersetuju dengan <a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Terma Penggunaan</a> dan <a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Dasar Privasi</a> Flywire",
  'bankAccountForm.labels.termsDirectDebit':
    'Saya mengesahkan bahawa saya ialah pemilik akaun ini dan satu-satunya penandatangan yang diperlukan untuk membenarkan debit langsung ini',
  'bankAccountForm.labels.termsEft':
    "Saya telah membaca, memahami dan bersetuju dengan <a class='fw-underline fw-text-primary-600' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Perjanjian Debit Pra-Dibenarkan</a>",
  'bankAccountForm.labels.city': 'Bandar',
  'bankAccountForm.labels.country': 'Negara atau rantau',
  'bankAccountForm.labels.selectCountry': 'Pilih negara atau rantau',
  'bankAccountForm.title': 'Maklumat pemegang akaun',
  'failure.tryAgain': 'Cuba lagi',
  'failure.title': 'Transaksi gagal',
  'failure.connectivity.message': 'Operasi gagal, ini mungkin disebabkan oleh masalah sambungan.',
  'failure.message':
    'Transaksi gagal. Ini mungkin disebabkan oleh masalah sambungan. Sila cuba lagi. Jika masalah berterusan, sila cuba kaedah pembayaran lain atau hubungi bank anda',
  'sessionExpired.text': 'Sesi telah tamat tempoh',
  'LoadingError.title': 'Sesuatu telah berlaku',
  'LoadingError.message': 'Ralat berlaku semasa memuatkan borang',
  'tokenizationForm.errors.noPaymentOptionsAvailable':
    'Tiada pilihan pembayaran tersedia untuk negara/rantau yang dipilih',
  'offerError.noOptions.card':
    'Jenis kad yang dipilih tidak disokong. Sila gunakan jenis kad lain.',
  'offerError.noOptions.bank':
    'Akaun bank yang dipilih tidak disokong. Sila gunakan akaun bank lain.',
  'offerError.noOptions.other':
    'Kaedah pembayaran yang dipilih tidak disokong. Sila gunakan kaedah pembayaran lain.',
  'bankAccountForm.labels.accountHolderType.personal': 'Akaun peribadi',
  'bankAccountForm.labels.accountHolderType.business': 'Akaun perniagaan',
  'bankAccountForm.labels.name': 'Nama pertama',
  'bankAccountForm.labels.businessName': 'Nama perniagaan',
  'bankAccountForm.labels.surname': 'Nama keluarga',
  'bankAccountForm.labels.phone': 'Nombor telefon',
  'bankAccountForm.labels.email': 'E-mel',
  'bankAccountForm.labels.zip': 'Poskod',
  'bankAccountForm.labels.accountAddress': 'Alamat',
  'bankAccountForm.labels.address': 'Alamat',
  'bankAccountForm.errors.dynamicFields': '{{field}} tidak sah',
  'bankAccountForm.labels.saveButton': 'Simpan',
  'bankAccountForm.labels.nextButton': 'Seterusnya',
  'bankAccountForm.labels.payButton': 'Bayar',
  'bankAccountForm.errors.cardNumber': 'Nombor kad tidak sah',
  'tokenizationForm.errors.cardNumber': 'Nombor kad tidak sah',
  'tokenizationForm.errors.cvv': 'Nombor CVV tidak sah',
  'bankAccountForm.errors.cvv': 'Nombor CVV tidak sah',
  'tokenizationForm.errors.unsupportedCardTypes': 'Hanya {{acceptedCardsList}} disokong',
  'tokenizationForm.errors.unsupportedCardType': 'Hanya {{acceptedCard}} disokong',
  'tokenizationForm.errors.cardType.and': 'dan',
  'tokenizationForm.errors.name': 'Nama pertama tidak sah',
  'tokenizationForm.errors.email': 'E-mel tidak sah',
  'tokenizationForm.errors.country': 'Negara atau rantau tidak sah',
  'tokenizationForm.errors.state': 'Negeri tidak sah',
  'tokenizationForm.errors.city': 'Bandar tidak sah',
  'tokenizationForm.errors.address': 'Alamat tidak sah',
  'tokenizationForm.errors.addressIsPoBox':
    'Kami tidak menerima Peti Surat (PO Box) dalam ruangan alamat.',
  'tokenizationForm.errors.onlyLetterOrNumbers': 'Aksara yang sah hanyalah A-Z dan 0-9',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol':
    'Aksara yang sah hanyalah A-Z, 0-9 dan "/, -"',
  'tokenizationForm.errors.zip': 'Poskod tidak sah',
  'tokenizationForm.errors.expiryDate': 'Tarikh luput tidak sah',
  'bankAccountForm.errors.expiryDate': 'Tarikh luput tidak sah',
  'tokenizationForm.errors.surname': 'Nama keluarga tidak sah',
  'tokenizationForm.errors.phone': 'Nombor telefon tidak sah',
  'tokenizationForm.errors.length': 'Ruangan terlalu panjang (maksimum 256 aksara)',
  'tokenizationForm.errors.required.field': 'Ruangan wajib diisi',
  'bankAccountForm.errors.name': 'Nama pertama tidak sah',
  'bankAccountForm.errors.name.maxSizeExceeded':
    'Nama pertama terlalu panjang (maksimum 140 aksara)',
  'form.errors.name.maxSizeExceeded': 'Nama pertama terlalu panjang (maksimum {{limit}} aksara)',
  'form.errors.surname.maxSizeExceeded':
    'Nama keluarga terlalu panjang (maksimum {{limit}} aksara)',
  'form.errors.business_name.maxSizeExceeded':
    'Nama perniagaan terlalu panjang (maksimum {{limit}} aksara)',
  'form.errors.city.maxSizeExceeded': 'Bandar terlalu panjang (maksimum {{limit}} aksara)',
  'form.errors.address.maxSizeExceeded': 'Alamat terlalu panjang (maksimum {{limit}} aksara)',
  'form.errors.date.wrongDate': 'Nilai pemilih tarikh tidak sah',
  'bankAccountForm.errors.business_name': 'Nama perniagaan tidak sah',
  'bankAccountForm.errors.business_name.maxSizeExceeded':
    'Nama perniagaan terlalu panjang (maksimum 140 aksara)',
  'bankAccountForm.errors.surname': 'Nama keluarga tidak sah',
  'bankAccountForm.errors.surname.maxSizeExceeded':
    'Nama keluarga terlalu panjang (maksimum 140 aksara)',
  'bankAccountForm.errors.country': 'Negara atau rantau tidak sah',
  'bankAccountForm.errors.address': 'Alamat tidak sah',
  'bankAccountForm.errors.address.maxSizeExceeded': 'Alamat terlalu panjang (maksimum 256 aksara)',
  'bankAccountForm.errors.city': 'Bandar tidak sah',
  'bankAccountForm.errors.city.maxSizeExceeded': 'Bandar terlalu panjang (maksimum 256 aksara)',
  'bankAccountForm.errors.email': 'E-mel tidak sah',
  'bankAccountForm.errors.state': 'Negeri tidak sah',
  'bankAccountForm.errors.iban': 'IBAN tidak sah',
  'bankAccountForm.errors.bic': 'Kod BIC tidak sah',
  'bankAccountForm.errors.accountnumber': 'Nombor akaun tidak sah',
  'bankAccountForm.errors.sortcode': 'Kod sort tidak sah',
  'bankAccountForm.errors.account_type': 'Jenis akaun tidak sah',
  'bankAccountForm.errors.addressIsPoBox':
    'Kami tidak menerima Peti Surat (PO Box) dalam ruangan alamat.',
  'bankAccountForm.errors.onlyLetterOrNumbers': 'Aksara yang sah hanyalah A-Z dan 0-9',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': 'Aksara yang sah ialah: A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': 'Poskod tidak sah',
  'bankAccountForm.errors.phone': 'Nombor telefon tidak sah',
  'bankAccountForm.errors.ach_account_number': 'Nombor akaun tidak sah',
  'bankAccountForm.errors.routing_number': 'Nombor penghalaan tidak sah',
  'bankAccountForm.errors.offer':
    'Tiada pilihan pembayaran tersedia - Jika anda mempunyai akaun bank di negara/rantau lain, sila pilih negara/rantau tersebut atau pilih kad lain dan cuba lagi. Jika ini tidak menyelesaikan masalah, sila hubungi {{recipientName}}',
  'binLookUp.unableToFindCard.message':
    'Ralat kad. Semak butiran kad yang anda masukkan atau cuba kad lain.',
  'binLookUp.warning.message': 'Kami tidak dapat mengesahkan kad anda',
  'confirmationPage.labels.edit': 'Edit',
  'confirmationPage.labels.confirm': 'Sahkan',
  'confirmationPage.labels.title': 'Semak maklumat mandat',
  'confirmationPage.labels.typeOfPayment': 'Jenis pembayaran',
  'confirmationPage.labels.paymentRecipient': 'Penerima pembayaran',
  'confirmationPage.labels.typeOfPayment.oneOff': 'Sekali sahaja',
  'confirmationPage.labels.typeOfPayment.recurring': 'Berulang',
  'confirmationPage.labels.directDebitInformation': 'Maklumat debit langsung',
  'confirmationPage.labels.directDebitInformation.title': 'Arahan kepada bank anda',
  'confirmationPage.labels.directDebitInformation.creditor': 'Pemiutang',
  'confirmationPage.labels.directDebitInformation.creditorId': 'ID pemiutang',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': 'Nama dalam penyata anda',
  'confirmationPage.labels.directDebitInformation.serviceUserId': 'ID pengguna perkhidmatan',
  'confirmationPage.labels.directDebitInformation.address': 'Alamat Flywire',
  'confirmationPage.labels.directDebitInformation.originator': 'Pemula',
  'confirmationPage.labels.directDebitInformation.originatorId': 'ID pemula',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'Alamat pemula',
  'confirmationPage.labels.bankAccountInformation': 'Maklumat akaun bank',
  'confirmationPage.labels.bankAccountInformation.name': 'Nama',
  'confirmationPage.labels.bankAccountInformation.iban': 'Nombor IBAN',
  'confirmationPage.labels.bankAccountInformation.email': 'E-mel',
  'confirmationPage.labels.bankAccountInformation.country': 'Negara atau rantau',
  'confirmationPage.labels.bankAccountInformation.state': 'Negeri',
  'confirmationPage.labels.bankAccountInformation.city': 'Bandar',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'Kod BIC',
  'confirmationPage.labels.bankAccountInformation.accountNumber': 'Nombor akaun',
  'confirmationPage.labels.bankAccountInformation.sortCode': 'Kod sort',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': 'Nombor akaun',
  'confirmationPage.labels.bankAccountInformation.routingNumber': 'Nombor penghalaan',
  'confirmationPage.labels.bankAccountInformation.accountType': 'Jenis akaun',
  'confirmationPage.labels.paymentInformation': 'Maklumat pembayaran',
  'confirmationPage.labels.paymentInformation.amount': 'Jumlah',
  'confirmationPage.labels.changeAccountEft': 'Tukar butiran akaun bank',
  'confirmationPage.labels.editPayerEft': 'Edit butiran pembayar',
  'confirmationPage.labels.useAccountEft': 'Gunakan akaun yang berakhir dengan **** {{lastFour}}',
  'confirmationPage.labels.bankLinkSuccessMessage': 'Akaun bank berjaya dipautkan',
  'confirmationPage.labels.termsSepa':
    'Dengan menandatangani borang mandat ini, anda memberi kebenaran kepada (A) FLYWIRE EUROPE UAB untuk menghantar arahan kepada bank anda untuk mendebitkan akaun anda dan (B) bank anda untuk mendebitkan akaun anda mengikut arahan daripada FLYWIRE EUROPE UAB. Anda akan dimaklumkan sekurang-kurangnya 3 hari sebelum caj dikenakan.',
  'confirmationPage.labels.termsBacs':
    'Mengarahkan bank anda untuk membayar Debit Langsung Flywire Payments Limited daripada akaun yang dinyatakan dalam arahan ini tertakluk kepada perlindungan yang dijamin oleh Jaminan Debit Langsung. Saya faham bahawa arahan ini mungkin kekal bersama Flywire Payments Limited dan, jika demikian, butiran akan dihantar secara elektronik kepada bank/persatuan pembinaan saya.',
  'confirmationPage.labels.termsAch':
    '\n     Dengan mengklik "Sahkan", anda mengesahkan bahawa anda mempunyai kuasa yang sewajarnya untuk dan dengan ini membenarkan Flywire bagi pihak penerima yang dinyatakan\n     ("Penerima Bayaran") untuk mendebitkan akaun bank yang anda sediakan bagi sebarang jumlah yang terhutang untuk caj yang timbul daripada penggunaan perkhidmatan Penerima Bayaran oleh anda\n     dan/atau pembelian produk daripada Penerima Bayaran, dan jika perlu, untuk membetulkan debit yang tersilap, menurut terma Penerima Bayaran, sehingga\n     kebenaran ini ditarik balik. Sekiranya transaksi ACH ditolak kerana dana tidak mencukupi, saya faham bahawa saya akan dikenakan\n     yuran NSF, dan Flywire mungkin mengikut budi bicaranya cuba memproses caj tersebut sekali lagi.\n     ',
  'confirmationPage.labels.termsAch2':
    '\n     Jika anda menggunakan atau membeli produk dan/atau perkhidmatan tambahan daripada Penerima Bayaran secara berkala, menurut terma Penerima Bayaran, anda membenarkan\n     Flywire, bagi pihak Penerima Bayaran, untuk mendebitkan akaun bank yang anda sediakan secara berkala. Pembayaran yang berada di luar debit\n     yang dibenarkan di atas hanya akan didebitkan selepas kebenaran anda diperoleh melalui akaun anda, atau melalui kata laluan, kod atau\n     tandatangan setara yang lain.\n     ',
  'confirmationPage.labels.termsAch3':
    '\n     Anda boleh menarik balik kebenaran ini pada bila-bila masa dengan menghubungi Penerima Bayaran. Penarikan balik anda mestilah diterima sekurang-kurangnya [10 hari bekerja]\n     sebelum pembayaran berjadual yang seterusnya.\n    ',
  'confirmationPage.labels.print': 'Cetak perjanjian',
  'amountPanel.labels.amountFromLabel': 'Anda akan membayar',
  'amountPanel.labels.surchargeFeeInfo': 'termasuk yuran kad',
  'amountPanel.labels.serviceFeeInfo': 'termasuk yuran perkhidmatan',
  'amountPanel.labels.serviceFeePercentageInfo':
    'Yuran perkhidmatan {{percentage}} (min. {{minimumFee}})',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': 'Yuran perkhidmatan {{percentage}}',
  'amountPanel.labels.whyThisFee': 'Mengapa yuran ini?',
  'amountPanel.labels.currencyChangeWarning':
    'Mata wang telah ditukar supaya sepadan dengan mata wang kad anda',
  'amountPanel.labels.amountToLabel': '{{recipientName}} akan menerima',
  'amountPanel.labels.editCurrencySelection': 'Edit pilihan mata wang',
  'amountPanel.labels.discountApplied': 'Diskaun {{amount}} telah dikenakan',
  'currencyInfoBanner.labels.currencyInfo':
    'Anda akan dicaj dalam <b>{{code}} ({{symbol}})</b> untuk pembayaran anda yang akan datang.',
  'currencyInfoBanner.error.offerNotFound': 'Tiada pilihan pembayaran tersedia.',
  AX: 'Kepulauan Åland',
  AD: 'Andorra',
  BG: 'Bulgaria',
  AT: 'Austria',
  BE: 'Belgium',
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Republik Czech',
  DK: 'Denmark',
  EE: 'Estonia',
  FI: 'Finland',
  FR: 'Perancis',
  GP: 'Guadeloupe',
  DE: 'Jerman',
  GR: 'Greece',
  HU: 'Hungary',
  IS: 'Iceland',
  IE: 'Ireland',
  VA: 'Holy See (Negara Kota Vatican)',
  IT: 'Itali',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  YT: 'Mayotte',
  MT: 'Malta',
  MQ: 'Martinique',
  ES: 'Sepanyol',
  NO: 'Norway',
  NL: 'Belanda',
  PL: 'Poland',
  PT: 'Portugal',
  SE: 'Sweden',
  RE: 'Réunion',
  RO: 'Romania',
  CH: 'Switzerland',
  BL: 'Saint Barthélemy',
  GB: 'United Kingdom',
  MC: 'Monaco',
  MF: 'Saint Martin (bahagian Perancis)',
  PM: 'Saint Pierre dan Miquelon',
  SM: 'San Marino',
  SK: 'Slovakia',
  SI: 'Slovenia',
  GF: 'Guiana Perancis',
  LV: 'Latvia',
  CA: 'Kanada',
  US: 'Amerika Syarikat',
  'inlineDialogConfirmation.labels.title': 'Pengesahan diperlukan: Batalkan proses',
  'inlineDialogConfirmation.labels.body': 'Adakah anda pasti mahu membatalkan proses ini?',
  'inlineDialogConfirmation.labels.closeButton': 'Tidak',
  'inlineDialogConfirmation.labels.confirmButton': 'Ya',
  'priceBreakDown.price.toggle.button': 'Pecahan harga',
  'priceBreakDown.fx.toggle.button': 'Pecahan FX',
  'priceBreakDown.fees': 'Yuran',
  'priceBreakDown.service_fees': 'Yuran perkhidmatan',
  'priceBreakDown.card_fees': 'Yuran kad',
  'priceBreakDown.exchange.rate': 'Kadar pertukaran',
  'priceBreakDown.markup.rate': 'Tambahan atas kadar ECB',
  'priceBreakDown.discount': 'Diskaun',
  'priceBreakDown.discount.coupon': 'Diskaun ({{code}})',
  'priceBreakDown.original_amount': 'Jumlah asal',
  'priceBreakDown.total': 'Jumlah',
  'acceptProposedOfferBanner.textInfo':
    "Kad ini tidak layak. Ketik 'Terima' untuk meneruskan ke kaedah pembayaran yang disokong atau ",
  'acceptProposedOfferBanner.textInfoWithoutChangeCard':
    "Kad ini tidak layak. Ketik 'Terima' untuk meneruskan ke kaedah pembayaran yang disokong.",
  'acceptProposedOfferBanner.link.option': 'tukar kad',
  'acceptProposedOfferBanner.labels.accept': 'Terima',
  'chooseCurrencyBanner.title': 'Pilih mata wang',
  'chooseCurrencyBanner.message':
    'Mata wang kad anda berbeza daripada mata wang negara pengebilan anda. Sila pilih mata wang yang ingin anda gunakan untuk transaksi ini:',
  'banner.offer.validation.message': 'Anda perlu memilih satu tindakan untuk meneruskan.',
  'instructions.offline.amount.label': 'Jumlah yang perlu dibayar',
  'instructions.offline.reference.label': 'Rujukan / ID pembayaran',
  'instructions.offline.paymentId.label': 'ID pembayaran',
  'instructions.offline.paymentReferenceMissing': 'Rujukan pembayaran tidak wujud',
  'instructions.offline.missing.title': 'Arahan pembayaran anda tidak dapat dijana',
  'instructions.offline.missing.message':
    'Sila cuba lagi. Jika masalah berterusan, sila cuba kaedah pembayaran lain atau hubungi bank anda.',
  'instructions.offline.title': 'Arahan pembayaran',
  'instructions.offline.understand':
    'Saya faham bahawa saya perlu memulakan pemindahan dari bank saya.<br />Klik di sini untuk menutup.',
  'instructions.offline.download.button': 'Muat turun arahan untuk pemindahan bank',
  'instructions.offline.howToBankTransfer': 'Bagaimana untuk membuat pemindahan bank?',
  'instructions.offline.howToBankTransfer.modal.title': 'Cara melengkapkan pemindahan bank anda',
  'instructions.offline.howToBankTransfer.modal.intro':
    'Berikut ialah pelbagai pilihan yang boleh anda gunakan untuk melengkapkan pemindahan bank anda:',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle':
    'Perbankan dalam talian / Perbankan mudah alih',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription':
    'Jika anda mempunyai perbankan dalam talian atau aplikasi mudah alih daripada bank anda, anda boleh log masuk ke akaun anda dengan mudah dan membuat pemindahan sendiri.',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': 'Lawatan sendiri ke cawangan bank',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription':
    'Dengan melawat cawangan bank tempatan anda secara peribadi, anda boleh memberikan kepada bank butiran akaun yang diperlukan yang terdapat dalam arahan pembayaran anda untuk membuat pemindahan.',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': 'Pemindahan melalui telefon',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription':
    'Anda juga boleh menghubungi bank anda dan memberi kebenaran kepada mereka untuk memulakan transaksi bagi pihak anda.',
  'instructions.offline.referenceWarning':
    'Anda mesti menyertakan rujukan ini supaya kami dapat mengenal pasti pembayaran anda',
  'instructions.offline.dueDateLabel': 'Pindahkan dana sebelum:',
  'instructions.offline.processingTime':
    'Flywire akan menerima dana: <strong>2-3 hari bekerja</strong> selepas anda memulakan pemindahan',
  'elementsInstructions.qr.description': 'Imbas kod QR untuk melengkapkan pembayaran',
  'elementsInstructions.qr.payid.description':
    'Buka aplikasi perbankan anda dan hantar kepada PayID di bawah. Alamat ini ditetapkan secara eksklusif untuk akaun anda — pembayaran dipadankan secara automatik.',
  'elementsInstructions.qr.scan': 'Atau imbas dengan kamera telefon anda',
  'elementsInstructions.qr.waitingForPayment': 'Menunggu pembayaran selesai',
  'elementsInstructions.externalAction.generic': 'Sila lengkapkan pembayaran untuk meneruskan.',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone':
    'Permintaan pembayaran M-Pesa telah dihantar ke telefon anda.\nSila lengkapkan pembayaran untuk meneruskan.',
  'elementsInstructions.redirect.title': 'Lengkapkan pembayaran anda',
  'elementsInstructions.redirect.description':
    'Anda akan dibawa ke platform pemprosesan rakan kongsi untuk melengkapkan pembayaran ini. Setelah selesai, anda akan dialihkan semula ke halaman ini.',
  'elementsInstructions.redirect.button': 'Buat pembayaran anda',
  'documentCollector.collapsibleTitle': 'Muat naik dokumentasi',
  'documentCollector.uploadingDocument': 'Memuat naik dokumen',
  'documentCollector.deleteFile': 'Padam {{fileName}}',
  'documentCollector.deletingFile': 'Memadam {{fileName}}',
  'documentCollector.moreInfoModal': 'Maklumat lanjut',
  'documentCollector.errorsModal': 'Amaran dokumen',
  'documentCollector.documentList': 'Senarai dokumen',
  'documentCollector.upload': 'Muat naik',
  'documentCollector.errorBlockLabel': 'Amaran dokumen',
  'documentCollector.reUpload': 'Muat naik semula',
  'documentCollector.errorsFoundOne': '{{count}} amaran ditemui',
  'documentCollector.errorsFoundOther': '{{count}} amaran ditemui',
  'documentCollector.validationNote':
    '<b>Muat naik fail selesai!</b> Imbasan automatik kami telah menandakan kemungkinan isu. Jika dokumen anda mengandungi semua maklumat yang diperlukan, abaikan amaran ini.',
  'documentCollector.antivirus': 'Imbasan fail antivirus',
  'documentCollector.antivirusStep': 'Imbasan fail antivirus 1/2',
  'documentCollector.verifyingStep': 'Mengesahkan dokumen 2/2',
  'documentCollector.invalidFile':
    'Fail tidak sah dikesan. Fail mungkin dilindungi kata laluan atau disulitkan. Sila semak dan cuba lagi.',
  'documentCollector.moreInfo': 'Maklumat lanjut',
  'documentCollector.required': 'Wajib',
  'documentCollector.review': 'Semak',
  'documentCollector.acceptedFileTypes':
    'Jenis fail yang diterima: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>',
  'documentCollector.maxFileSize': 'Saiz fail maksimum: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.acceptedFileAndFileSize':
    'Jenis fail yang diterima: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>. Saiz fail maksimum: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.docVerifyError.missingInfo':
    'Sila semak bahawa dokumen mengandungi semua maklumat yang diminta.',
  'documentCollector.docVerifyError.documentTypeError':
    'Ini tidak kelihatan seperti {{documentType}}. Sila semak keperluan dan muat naik fail baharu jika perlu.',
  'documentCollector.docVerifyError.documentIdentificationTypeError':
    'Dokumen yang dimuat naik tidak kelihatan seperti {{documentType}}, iaitu jenis pengenalan yang anda pilih untuk pembayaran ini. Sila semak dan muat naik semula jika perlu.',
  'documentCollector.docVerifyError.documentType.errorNote':
    '<b>Nota</b>: Penghantaran dokumen yang tidak betul boleh menyebabkan kelewatan dalam memproses pembayaran. Jika dokumen anda sah, sila abaikan nota amaran ini.',
  'documentCollector.duplicateFile':
    'Dokumen pendua dikesan. Sila muat naik fail yang berbeza untuk setiap satu.',
  'oneOff.savePaymentMethod.label': 'Simpan kaedah pembayaran ini untuk pembayaran akan datang',
  'lrs.transaction.title': 'Transaksi',
  'lrs.transaction.date': 'Tarikh',
  'lrs.transaction.amount': 'Jumlah',
  'lrs.transaction.amountHint': 'Jumlah dalam mata wang asing',
  'lrs.transaction.adBranch': 'Nama dan alamat cawangan AD',
  'lrs.transaction.add': 'Tambah lebih banyak transaksi',
  'lrs.signatureModal.title': 'Tandatangani dokumen',
  'lrs.signatureModal.tab.draw': 'Lukis tandatangan',
  'lrs.signatureModal.tab.upload': 'Muat naik tandatangan',
  'lrs.signatureModal.draw.text':
    'Tandatangan di ruang yang disediakan di bawah menggunakan tetikus atau jari anda untuk menerima dokumen.',
  'lrs.signatureModal.legalAlert':
    'Tandatangan yang tidak sah akan membatalkan keseluruhan proses LRS. Sila pastikan anda menandatangani dengan <b>tandatangan pemegang PAN</b>. Satu salinan dokumen akan dihantar ke e-mel pembayar yang diberikan untuk rujukan anda pada masa hadapan. Jenis fail yang diterima: <b>PNG</b>, <b>JPG</b>.',
  'lrs.signatureModal.draw.clear': 'Kosongkan',
  'lrs.signatureModal.upload.label': 'Muat naik versi imej tandatangan anda',
  'lrs.signatureModal.upload.input': 'Muat naik tandatangan',
  'lrs.signatureModal.upload.remove': 'Alih keluar',
  'lrs.signatureModal.upload.hint':
    'Jenis fail yang diterima: <b>PNG</b>, <b>JPG</b>. Saiz fail maksimum: <b>8MB</b>',
  'lrs.signatureModal.upload.typeError': 'Jenis fail tidak disokong. Sila muat naik PNG atau JPG.',
  'lrs.signatureModal.upload.sizeError': 'Fail mestilah lebih kecil daripada 8MB',
  'lrs.signatureModal.upload.readError': 'Fail tidak dapat dibaca. Sila cuba lagi.',
  'lrs.signatureModal.confirm': 'Terima dan hantar',
  'lrs.signatureModal.previewError':
    'Sesuatu telah berlaku semasa menjana pratonton. Sila cuba lagi.',
  'lrs.signatureModal.uploadError': 'Sesuatu telah berlaku semasa menghantar. Sila cuba lagi.',
  'lrs.previewLink.label': 'Pratonton dokumen',
  'lrs.documents.continueButton': 'Teruskan untuk menghantar borang LRS',
  'lrs.form.declaration':
    "Di bawah Skim Remitan Dibebaskan (LRS), kerajaan India dan Bank Rizab India (RBI) kini memerlukan borang Perisytiharan LRS (bertajuk penuh \"A2 cum LRS Declaration\") untuk memindahkan dana ke luar negara. ADALAH WAJIB untuk menghantar Perisytiharan LRS anda sebelum memulakan pemindahan bank anda, jika tidak, pembayaran anda mungkin mengalami kelewatan dalam pemprosesan. Untuk butiran lanjut tentang cara melengkapkan langkah ini, klik <a href='https://help.flywire.com/hc/en-us/articles/360012963774' target='_blank'>di sini</a> untuk mengetahui lebih lanjut.",
  'lrs.form.bankAccountAndStudentInfo.title': 'Akaun bank dan maklumat pelajar',
  'lrs.form.bankAccountAndStudentInfo.text':
    'Sila nyatakan akaun bank yang akan digunakan untuk memindahkan dana. Jika anda telah mengambil pinjaman pendidikan dan dana akan dikeluarkan daripada akaun pinjaman anda, sila berikan nombor akaun pinjaman. Pemindahan daripada akaun NRO/NRE tidak diterima. Bagi ID pelajar, anda boleh menggunakan ID pelajar, ID permohonan atau nombor rujukan anda.',
  'lrs.form.details.title':
    'Butiran transaksi antarabangsa yang dibuat dalam tahun kewangan semasa',
  'lrs.form.details.text':
    'Sila berikan butiran sebarang transaksi mata wang asing yang telah anda lakukan dalam tahun kewangan semasa (<b>April {{startYear}} - Mac {{endYear}}</b>). Biarkan kosong jika anda tidak membuat sebarang transaksi.',
  'lrs.form.bankAccountNumber': 'Nombor akaun bank',
  'lrs.form.studentFullName': 'Nama penuh pelajar',
  'lrs.form.studentId': 'ID pelajar',
  'lrs.form.required': 'Wajib',
  'lrs.form.signAndSubmit': 'Tandatangan dan hantar borang LRS',
  'lrs.title': 'Muat naik dokumentasi dan hantar borang LRS',
  'lrs.description':
    'Anda akan melihat arahan pembayaran pemindahan bank setelah langkah ini selesai.',
  'lrs.tabs.documents': '1. Muat naik dokumen',
  'lrs.tabs.form': '2. Hantar borang LRS',
  'recipientFields.requiredField': '(*) ruangan wajib',
  'paymentMethodSelector.loading': 'Memuatkan kaedah pembayaran...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': 'Menerima kad debit dan kad kredit',
  'paymentMethodSelector.cards.acceptsDebitOnly': 'Menerima kad debit',
  'paymentMethodSelector.cards.acceptsCreditOnly': 'Menerima kad kredit',
  'paymentMethodSelector.cards.surchargeWarning':
    'Surcaj mungkin dikenakan bergantung pada jenis kad dan negara pengeluar.',
  'paymentMethodSelector.subtitle.default': 'Bayar dengan {{methodName}}',
  'paymentMethodSelector.subtitle.google_pay': 'Bayar dengan dompet Google Pay anda yang tersimpan',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID atau Face ID — Safari sahaja',
  'paymentMethodSelector.subtitle.paypal': 'Bayar dengan akaun PayPal anda',
  'paymentMethodSelector.subtitle.wechat': 'Bayar dengan WeChat — tersedia di tanah besar China',
  'paymentMethodSelector.subtitle.alipay': 'Bayar dengan Alipay',
  'paymentMethodSelector.subtitle.trustly': 'Pembayaran perbankan terbuka'
} as const;

export { msMY };
